import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { differenceInDays, eachDayOfInterval } from 'date-fns'

import calculateBoundaries from '../../helpers/calculateBoundaries'

import useStyles from './styles'

const BoundaryLines = ({ timelineStartDate, timelineEndDate }) => {
  const classes = useStyles()

  const boundaries = useMemo(() => {
    // Generate all dates in the range for timeline
    const allDates = eachDayOfInterval({ start: timelineStartDate, end: timelineEndDate })

    // Calculate total days and determine interval
    const totalDays = differenceInDays(timelineEndDate, timelineStartDate)

    let interval
    if (totalDays <= 3) {
      interval = 1 // daily — 1 line per day
    } else if (totalDays <= 7) {
      interval = 2 // every 2 days
    } else if (totalDays <= 14) {
      interval = 3 // every 3 days
    } else if (totalDays <= 30) {
      interval = 7 // weekly
    } else if (totalDays <= 60) {
      interval = 14 // bi-weekly
    } else {
      interval = 30 // monthly for 60+ days
    }

    return calculateBoundaries(timelineStartDate, timelineEndDate, allDates, interval)
  }, [timelineStartDate, timelineEndDate])

  return (
    <>
      {boundaries.map(boundary => {
        const left = `${boundary.leftPercentage}%`

        return (
          <div key={boundary.date.getTime()}>
            <div
              className={classes.dashedVerticalLine}
              style={{
                left: left
              }}
            />
            <div
              className={classes.label}
              style={{
                left: left
              }}
            >
              {boundary.label}
            </div>
          </div>
        )
      })}
    </>
  )
}

BoundaryLines.propTypes = {
  timelineStartDate: PropTypes.instanceOf(Date).isRequired,
  timelineEndDate: PropTypes.instanceOf(Date).isRequired
}

export default BoundaryLines
